<div class="currentAgentStatesTableView h-100 w-100 d-flex flex-column">
    <!-- Search cxone -->
    <div class="cxone-live-search ml-2 my-2" [hidden]="!showFilter">
       <cxone-text-input #filterInput [(ngModel)]="filterValue" [placeholder]="searchPlaceholder" (keyup)="applyFilter()" class="cxone-widget-search" name="cxoneInput-{{moduleKey}}"
           (ngModelChangeDebounced)="filterValue" [ngModelChangeDebounceTime]="400"></cxone-text-input>
       <i class="cxone-search-icon" [hidden]="filterValue.length !== 0">
           <svg class="icon-18 fill-iconDefault-noHover cxone-search-wrapper">
               <use href="../App_Themes/CXone/icons/search.svg#search"></use>
           </svg>
       </i>
       <i [hidden]="filterValue.length === 0" (click)="clearFilter()">
           <svg class="icon-18 fill-iconDefault-noHover cxone-close-wrapper">
               <use href="../App_Themes/CXone/icons/close.svg#close"></use>
           </svg>
       </i>
    </div>

    <!-- Table -->
    <div [hidden]="noData" class="grid-container flex-fill overflow-auto">
        <ag-grid-angular 
            #agentListWidgetGrid
            *ngIf="gridOptions !== null"
            class="ag-theme-balham flex-fill h-100 w-100"
            [gridOptions]="gridOptions">
        </ag-grid-angular>
    </div>
</div>
